import Vue from 'vue'
import VueRouter from 'vue-router'
import checkin from '../views/checkin.vue'
import checkinlog from '../views/checkinlog.vue'
import error404 from '../views/404.vue'
import index from '../views/index.vue'

Vue.use(VueRouter)

  const routes = [
  { path: "*", component: index },
  {
    path: '/checkin/:branch_id',
    name: 'checkin',
    component: checkin,
  },
  {
    path: '/error404',
    name: 'error404',
    component: error404,
  },
  {
    path: '/checkinlog/:merchant_id',
    name: 'checkinlog',
    component: checkinlog,
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
